import { CheckoutCompletedOfferConfirmation } from '../../models/checkout-completed-item/checkout-completed-offer-confirmation.interface';

export const mockCheckoutCompletedOfferConfirmation: CheckoutCompletedOfferConfirmation =
  {
    breakdownStartDate: '2022-03-05',
    digitalId: undefined,
    planNumber: 'planNumber',
    renewalDate: '2022-03-05',
  };
